// 全局参数表

const globalParams = new Map();

export default {
  get(key, defaultValue) {
    const value = globalParams.get(key);
    if (typeof value === "undefined") {
      return defaultValue;
    }
    if (value === null) {
      return defaultValue;
    }
    return value;
  },

  getFn(key, args, defaultValue) {
    const value = globalParams.get(key);
    if (typeof value === "undefined") {
      return defaultValue;
    }
    if (value === null) {
      return defaultValue;
    }
    if (typeof value === 'function') {
      return value.apply(this, args);
    }
    return value;
  },

  set(key, value) {
    globalParams.set(key, value);
  }
};
